import { Tags, TagsApi, TagTypesApi } from '../../oas';
import { TagResponse, TagsApi as InternalTagsApi } from '../../oas/internal';
import { UseQueryResult } from '@tanstack/react-query';
import { mockResponse, useApiQuery } from '../use-api-query';
import { API_NAMES } from '../constants';

export const useGetAllTagsOfTagType: (
    ...parameters: Parameters<TagsApi['getAllTagsOfTagType']>
) => UseQueryResult<Tags[]> = (tagType, options = {}) => {
    return useApiQuery(
        ['tags', 'tag_type', tagType],
        (apiConfig, axiosInstance) => {
            return tagType
                ? new TagsApi(apiConfig, '', axiosInstance).getAllTagsOfTagType(tagType, options)
                : mockResponse([]);
        },
        {
            staleTime: 3600000,
        },
    );
};

export const useGetAllTagTypes: () => UseQueryResult<Tags[]> = () => {
    return useApiQuery(['tags', 'tag_type'], (apiConfig, axiosInstance) => {
        return new TagTypesApi(apiConfig, '', axiosInstance).getAllTagTypes();
    });
};

export const useGetTags = (options = {}): UseQueryResult<TagResponse[]> => {
    return useApiQuery(
        ['tags', 'internal'],
        (apiConfig, axiosInstance) => new InternalTagsApi(apiConfig, '', axiosInstance).getTags(),
        options,
        'internal',
        API_NAMES.ACTIVITY_SERVICE,
    );
};
